import { Plugin } from "vue-fragment";
import installFragmentSiblingFix from "../global-declare-components/plugins/fragment-sibling-fix";
import "./plugins/vee-validate";
import "./plugins/fa-icons-plugin";
import store from "./store";

Vue.use(Plugin);
// Undo vue-fragment's over-broad sibling freeze (breaks vuedraggable / Vue patch).
installFragmentSiblingFix();

Vue.component("registration-modal", require("./ui/registration-modal/index").default);
Vue.component("agenda-list", require("./ui/agenda-list/index").default);
Vue.component("speakers-list", require("./ui/speakers-list/index").default);
Vue.component("quick-registration", require("./ui/quick-registration/index").default);
Vue.component("event-checkbox", require("./ui/forms/event-checkbox").default);
Vue.component("event-radio", require("./ui/forms/event-radio").default);
Vue.component("event-spinner", require("./ui/shared/event-spinner").default);

Vue.component("video-player", require("./ui/video-player/index").default);

new Vue({
  el: "#event-landing",
  store
});
